import axios from "../../utils/axios";

export const updateLike = async ({likes, id}) => {
    const response = await axios.patch(`/blogs/${id}`, {
        likes: likes + 1,
      }, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });

  return response.data;
};
